// Classes.
import {BaseComponentLocator} from './base.component-locator';

// Interfaces.
import {ComponentLocatorInterface} from '../interfaces/component-locator.interface';


export class DateLocatorComponent extends BaseComponentLocator implements ComponentLocatorInterface {

  public constructor(protected _value: Date = null) {
    super();
  };

  public toString(): string {

    let str = 'DateNotSet';
    if (this._value) {
      str = [this._value.getFullYear(), this._value.getMonth() + 1, this._value.getDate()].join(('/'));
    }
    return str;
  }

  /**
   * value setter/getter.
   */
  set value(date: Date) {
    this._value = date;
  }

  get value(): Date {
    return this._value;
  }
}

